export const USER_AUTH = '/api/v1/user/auth'
export const USER_SIGNIN = '/api/v1/user/signIn'
export const USER_GRANT_ACCESS = '/api/v1/user/grantAccess'
export const PRIVATE_PLANS = '/private/v1/plans'
export const API_PLANS = '/api/v1/plans'
export const FIRMWARE_UPLOAD = '/private/v1/charger/firmware/upload'
export const FIRMWARE_CONFIG = '/private/v1/charger/firmware/config'



// WEBPACK FOOTER //
// ./src/lib/path.js